
import { h, Fragment, render } from 'preact'
import { useEffect } from 'preact/hooks'
import { createPortal } from 'preact/compat'
import { initialSessionFromDom, useSubmission } from './../hooks/useSubmission'

import { json } from './../utility/dom'
import { scrollTo } from './../utility/scrollTo'

import { Checkbox } from './../components/Checkbox'
import { FieldBasic } from './../components/FieldBasic'
import { FieldSelect } from './../components/FieldOptions'
import { FieldContainer } from './../components/FieldContainer'
import { FileUpload } from './../components/FileUpload'
import { SubmitButton } from './../components/SubmitButton'
import { ExpiryCounter } from './../components/ExpiryCounter'


export function init() {
	const registerEl = document.getElementById('register-form')
	const session = initialSessionFromDom()
	const stages = json('#form-stages')
	const siteSettings = json('#site-settings')
	registerEl && render(
		createPortal(<RegisterForm session={session} stages={stages} searchUrl={siteSettings.searchUrl} />, registerEl), 
		document.body
	)
}

function RegisterForm({ session, stages, searchUrl }) {

	const docs = ['Cv', 'CoverLetter']
	const beforeSubmit = data => ({
		...data,
		Stage: 'registerStages',
		GdprTime: (new Date()).toISOString(),
		GdprUseIP: true,
	})

	const onSuccess = () => window.location = stages.registerStages
	const onError = () => {
		setTimeout(() => {
			const el = document.querySelector('[class*="error"]')
			const fileField = el?.closest('.file-upload')
			const scrollEl = fileField || el
			scrollEl && scrollTo(scrollEl, -80)
		}, 20)
	}

	const { 
		fields, expires, validation, processing, submitted, 
		onSubmit, onInput, onInputDebounced, extendSession, resetSubmit,
		updateDocument, removeDocument 
	} = useSubmission({ session, beforeSubmit, onSuccess, onError })

	const titleOptions = ['Mr', 'Mrs', 'Miss', 'Ms', 'Mx', 'Captain', 'Professor', 'Doctor', 'Dame', 'Lady', 'Lord', 'Sir', 'Baroness', 'Baron']
	
	return <>
		<form onSubmit={onSubmit}>
			<input name="Type" type="hidden" value="register" />

			<div class="bg--white text-fade box-padding rounded border--lightgrey margin-bottom-5 first-last">

				{searchUrl && <div class="message-box margin-top-4 margin-bottom-4">
					If you are applying for a specific role, please <strong><a href={searchUrl}>search jobs</a></strong>
				</div>}

			    <h2 class="heading-5">Your details</h2>
			    <FieldSelect class="select--autowidth" name="Title" label="Title" value={fields.Title} options={titleOptions} onChange={onInput} error={validation.Title} />
				<FieldBasic name="Name" type="text" label="Full name" placeholder="Enter your full name" autocomplete="name" value={fields.Name} onBlur={onInput} error={validation.Name} />
				<FieldBasic name="Email" type="email" label="Email address" placeholder="e.g. email@domain.com" value={fields.Email} onBlur={onInput} error={validation.Email} />
				<FieldBasic name="Phone" type="tel" label="Phone number" placeholder="Enter your phone number" value={fields.Phone} onBlur={onInput} error={validation.Phone} />
				<FieldBasic name="CurrentPosition" label="Current position" value={fields.CurrentPosition} onBlur={onInput} error={validation.CurrentPosition} />
				<FieldBasic name="CurrentOrganisation" label="Current organisation" description="Please use official company name, or former company name" value={fields.CurrentOrganisation} onBlur={onInput} error={validation.CurrentOrganisation} />

				<FieldContainer class="margin-y-5" error={validation.EmploymentType}>
					<h2 class="heading-5">What kind of employment are you seeking?</h2>
					<p><small>Tick all that apply</small></p>
					<div className="button-row">
						<Checkbox large button name="EmploymentType" value="Permanent" label="Permanent" checked={fields.EmploymentType?.includes('Permanent')} onChange={onInput} />
						<Checkbox large button name="EmploymentType" value="Interim" label="Interim" checked={fields.EmploymentType?.includes('Interim')} onChange={onInput} />
						<Checkbox large button name="EmploymentType" value="NonExec" label="Non-executive" checked={fields.EmploymentType?.includes('NonExec')} onChange={onInput} />
					</div>
				</FieldContainer>

				<h2 class="heading-5 margin-top-3">CV</h2>
				<p><small>PDF or Word Document only, up to 3mb</small></p>
				<FileUpload 
					name="Cv" 
					initialValue={fields?.Cv?.DocumentId} 
					fileName={fields?.Cv?.OriginalDocumentName} 
					error={validation.Cv} 
					onFileSelect={updateDocument} 
			    	onFileDeselect={removeDocument} 
					accept=".pdf,application/pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
				/>
			</div>

			<div class="bg--white text-fade box-padding rounded border--lightgrey margin-bottom-5 first-last">
				<FieldContainer error={validation.Gdpr}>
				    <h2 class="heading-5">Your data</h2>
				    <div class="last margin-bottom-2" dangerouslySetInnerHTML={{ __html : session.gdprText}}></div>
				    {session.howWeUseYourData && <>
				    	<details class="margin-top-2 margin-bottom-4 text-main">
				    		<summary>How we use your data</summary>
				    		<div dangerouslySetInnerHTML={{ __html : session.howWeUseYourData}}></div>
				    	</details>
				    </>}
				    <input name="GdprText" type="hidden" value={session.gdprText} />
				    <Checkbox name="Gdpr" value="true" label="I agree" large button checked={fields.Gdpr} onChange={onInput} />
			    </FieldContainer>
			</div>

			<SubmitButton class="button button--fill button--yellow margin-bottom-5" processing={processing || submitted}>
				{(processing || submitted) && 'Processing' || 'Continue'}
			</SubmitButton>
			<ExpiryCounter expires={expires} onExtend={extendSession} />
		</form>
	</>
}












